import { styled } from '@mui/material';

import BaseButton from '../../../../../core/presentation/components/base-button/base-button';

export const ButtonAccess = styled(BaseButton)(() => ({
  color: '#515151',
  border: '1px solid #515151',
  gap: '20px'
}));
